// extracted by mini-css-extract-plugin
var _1 = "btn-close-err";
var _2 = "btnCriticalErrorClose";
var _3 = "button-container";
var _4 = "card";
var _5 = "error-header";
var _6 = "error-page-content";
var _7 = "mobile-card";
export { _1 as "btn-close-err", _2 as "btnCriticalErrorClose", _3 as "button-container", _4 as "card", _5 as "error-header", _6 as "error-page-content", _7 as "mobile-card" }
